export const inlineLoaderNode = `
    <div class="lds-ellipsis lds-ellipsis--reverse">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
`;
